module.exports = __webpack_public_path__ + "static/media/logo.87e8c7a3.png";